export default __webpack_public_path__ + "static/media/nihar.778c7d6a.jpeg";